import { useProceedingDelete } from '@/module/Author/Proceeding';

import { DeleteButton } from '@/core/components';

import { Id, useDelete } from '@feature/utils';

interface ProceedingDeleteButtonProps {
  proceedingId: Id;
}

export function ProceedingDeleteButton({ proceedingId }: ProceedingDeleteButtonProps) {
  const mutation = useProceedingDelete(proceedingId);
  const deleteProps = useDelete({
    mutation,
    navigateTo: { to: '..' },
  });

  return (
    <DeleteButton
      miw="100px"
      size="xs"
      {...deleteProps}
    />
  );
}
